<template lang="pug">
v-container
  //- Popup Create Stock
  v-dialog(v-model="show_create", max-width="600")
    Stock
  //- Header
  v-row(align="center", justify="space-between")
    v-col(cols="12", sm="2")
      h2.secondary--text Stock
    v-col(cols="12", sm="2")
      v-btn(outlined, color="secondary", @click="createStock") Añadir Stock
  v-divider
  //- List Stock
  Table(
    :loading="loading",
    :headers="headers",
    @edit="editStock",
    @delete="eraseStock",
    :items="stock.results",
    @getPage="getStockPage",
    :pageCount="stock.links.last_page",
    :itemsPerPage="stock.links.per_page"
  )
</template>

<script>
import stockAPI from "@/api/stock";
import Stock from "@/components/Stock";
import Table from "@/components/Table.vue";
import { mapState, mapGetters } from "vuex";

export default {
  name: "stocks",
  components: {
    Table,
    Stock,
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push("/auth/login");
    }
    await this.$store.dispatch(
      "providers/getProvidersWithoutPagination",
      this.auth_token
    );
    this.getStockPage(1);
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      auth_token: (state) => state.auth.auth_token,
      stock: (state) => state.stock.stocks,
    }),
    ...mapGetters({
      choices: "selectChoices",
    }),
  },
  data() {
    return {
      loading: false,
      show_create: false,
      headers: [
        { text: "Proveedor", value: "provider.description" },
        { text: "Fecha de Compra", value: "purchase_date" },
        { text: "Marca", value: "brand" },
        { text: "Stock", value: "stock" },
        { text: "Cantidad", value: "quantity" },
        { text: "Precio", value: "price" },
        { text: "Secuencia", value: "sequence" },
        { text: "Actiones", value: "actions" },
      ],
      messages_error_or_empty: "No tienes stocks registrados",
    };
  },
  methods: {
    createStock() {
      this.show_create = true;
    },
    async getStockPage(page) {
      this.loading = true;
      await this.$store.dispatch("stock/getStocks", {
        token: this.auth_token,
        page: page,
      });
      this.loading = false;
    },
    editStock(stock) {
      this.$router.push(`/stock/${stock.id}`);
    },
    async eraseStock(stock) {
      this.$swal({
        title: `¿Estas seguro de borrar stock de ${stock.brand}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.value) {
          const response = await stockAPI.deleteStock(
            stock.id,
            this.auth_token
          );

          if (response.status) {
            this.$swal({
              title: `Stock Borrado`,
              icon: "success",
            });
            await this.$store.dispatch("stock/getStocks", {
              token: this.auth_token,
              page: 1,
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error",
            });
          }
        }
      });
    },
  },
};
</script>
